// utils/triggeradfApi.ts
import axios from "axios";
import { ADF_ENDPOINTS } from "./adfEndpoints";

export const triggeradfPipeline = async (
  selectedDC: string,
  selectedTGTEnv: string,
  selectedTGTEnvReg: string,
  userId: string,
  interfaceName: string
): Promise<{ runId: string }> => {
  const response = await axios.post(
    ADF_ENDPOINTS.TRIGGER_PIPELINE,
    {
      parameters: {
        AUTO_INTERFACE_NM: interfaceName,
        AUTO_DST_CNTR: selectedDC,
        AUTO_TGT_ENV_CD: selectedTGTEnvReg === "VPT-U" ? "U" : "",
        AUTO_TGT_ENV: selectedTGTEnvReg,
        TRIGGER_ID: userId,
      },
    },
    { withCredentials: true }
  );
  return response.data; // should contain { runId }
};
